/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createUnaryMinus } from '../../factoriesAny.js';
export var unaryMinusDependencies = {
  typedDependencies,
  createUnaryMinus
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesUnaryMinus.generated.js
// module id = 102
// module chunks = 2